import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SingleSessionCodeState } from 'src/interfaces/store.types';
import { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: SingleSessionCodeState = {
  isSingleSessionCodeModalOpen: false,
};

export const singleSessionCodeSlice = createSlice({
  name: 'singleSessionCode',
  initialState,
  reducers: {
    setIsSingleSessionCodeModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isSingleSessionCodeModalOpen = action.payload;
    },
  },
});

export const { setIsSingleSessionCodeModalOpen } =
  singleSessionCodeSlice.actions;

export const useIsSingleSessionCodeModalOpen = () =>
  useAppSelector(
    (state: RootState) => state.singleSessionCode.isSingleSessionCodeModalOpen,
  );

export default singleSessionCodeSlice.reducer;
